/* eslint-disable */
import React from 'react';
import $i18n from "../../i18n";
import { defaultLangList, langList as allLangList } from "../../const/lang";
import { error } from "../../utils";
var PandaSwitcher = function PandaSwitcher(props) {
  var _CNUI;
  error('PandaSwitcher is deprecated, pls use CN-UI[CnI18nSelect] instead');
  if ((_CNUI = window.CNUI) !== null && _CNUI !== void 0 && _CNUI.CnI18nSelect) {
    var CnI18nSelect = window.CNUI.CnI18nSelect;
    return /*#__PURE__*/React.createElement(CnI18nSelect, props);
  }
  var langList = props.langList,
    _onChange = props.onChange;
  var usedLangList = langList ? allLangList.filter(function (item) {
    return langList.includes(item.value);
  }) : defaultLangList;
  return /*#__PURE__*/React.createElement("select", {
    onChange: function onChange(v) {
      var lang = v.target.value;
      if (_onChange) {
        _onChange(lang);
      } else {
        $i18n.setLang(lang);
      }
    }
  }, usedLangList.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.value,
      value: item.value
    }, item.label);
  }));
};
export default PandaSwitcher;